import { useBasicGiftCardContext } from '@/src/common/contexts/BasicGiftCardContext'
import Card from '@/src/common/components/marketing/cards/Card'

const SelectPackagingStep = () => {
    const { defaultImage, messageOnCard, nameOnCard, designImage } =
        useBasicGiftCardContext()

    return (
        <>
            <h1 style={{ marginTop: 0 }}>
                Select your <span className={'gradient'}>packaging</span>
            </h1>
            <Card
                size={'lg-with-xs-mobile'}
                image={designImage ? designImage : defaultImage}
                isExtended={!designImage}
                message={messageOnCard ? messageOnCard : 'Custom message'}
                name={nameOnCard ? nameOnCard : 'Recipient name'}
                overlayType={'full'}
            />
        </>
    )
}

export default SelectPackagingStep
